import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ConfirmCancelCheckModalProps {
  open: boolean;
  tableName: string;
  waiterName: string;
  itemCount: number;
  totalAmount: number;
  onConfirm: () => void;
  onCancel: () => void;
  isProcessing?: boolean;
}

const ConfirmCancelCheckModal: React.FC<ConfirmCancelCheckModalProps> = ({
  open,
  tableName,
  waiterName,
  itemCount,
  totalAmount,
  onConfirm,
  onCancel,
  isProcessing = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isProcessing ? undefined : onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: 24,
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: 'error.main',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          py: 2,
        }}
      >
        <WarningAmberIcon />
        <Typography variant="h6" component="div">
          Adisyon İptal Onayı
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ mt: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Alert severity="warning" icon={<CancelIcon />}>
            Adisyonu iptal etmek üzeresiniz! Bu işlem geri alınamaz.
          </Alert>

          <Box
            sx={{
              p: 2,
              bgcolor: 'background.default',
              borderRadius: 1,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Typography variant="body1" gutterBottom>
              <strong>Masa:</strong> {tableName}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Garson:</strong> {waiterName}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Ürün Sayısı:</strong> {itemCount} adet
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Toplam Tutar:</strong> ₺{totalAmount.toFixed(2)}
            </Typography>
          </Box>

          <Typography variant="body2" color="error" fontWeight="bold" align="center">
            Bu masadaki tüm ürünler silinecek ve adisyon iptal edilecektir.
          </Typography>
          
          <Typography variant="body2" color="text.secondary" align="center">
            İptal etmek istediğinizden emin misiniz?
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
        <Button
          onClick={onCancel}
          variant="outlined"
          color="inherit"
          size="large"
          disabled={isProcessing}
          sx={{ minWidth: 120 }}
        >
          Vazgeç
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          size="large"
          disabled={isProcessing}
          sx={{ minWidth: 120 }}
        >
          {isProcessing ? 'İptal Ediliyor...' : 'Adisyonu İptal Et'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmCancelCheckModal;

